import React from 'react';
import PropTypes from 'prop-types';
import { ForgeButton, ForgeIcon, ForgePageState } from '@tylertech/forge-react';

const GeneralEmptyState = ({
  buttonTitle= '',
  title = '',
  message = '',
  src,
  alt,
  handleClick=()=>{},
  showButton = true,
  buttonType = 'raised',
  iconName,
  scale = 1,
}) => {
  return (
    <div
      style={{
        width: '80%',
        margin: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        transform: `scale(${scale})`,
      }}
    >
      <ForgePageState>
        <img slot="graphic" src={src} alt={alt} />

        <p slot="title">{title}</p>
        <p slot="message">{message}</p>
        {showButton 
          ? <ForgeButton
            variant={buttonType}
            slot="action"
            onClick={() => handleClick()}
            style={{display:'block'}}
          >
            { iconName && <ForgeIcon external externalType="all"name={iconName}/>} 
            {buttonTitle}
          </ForgeButton>
          : null
        }
      </ForgePageState>
    </div>
  );
};

GeneralEmptyState.propTypes = {
  buttonTitle: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  handleClick: PropTypes.func,
  showButton: PropTypes.bool,
  buttonType: PropTypes.string,
  iconName: PropTypes.string,
  scale: PropTypes.number,
};

export default GeneralEmptyState;
